import React from 'react';

import { ContentWithImage } from 'utils/types';
import ExperienceSection from 'components/Enterprise/ExperienceSection';

export interface ExperienceContainerProps {
  content: {
    title: string;
    headline: string;
    listOfContentWithImages: ContentWithImage[];
    componentName: string;
  };
}

export const ExperienceContainer: React.FC<ExperienceContainerProps> = ({
  content,
}) => {
  if (!content) {
    return null;
  }

  const { title, headline, listOfContentWithImages } = content;

  return (
    <ExperienceSection
      title={title}
      headline={headline}
      listOfContent={listOfContentWithImages}
    />
  );
};

export default ExperienceContainer;
